import { render } from "./notice-detail.vue?vue&type=template&id=284d3c06"
import script from "./notice-detail.vue?vue&type=script&lang=js"
export * from "./notice-detail.vue?vue&type=script&lang=js"

import "./notice-detail.vue?vue&type=style&index=0&id=284d3c06&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__